/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  ListItemDesktopViewContent
 */
/** @jsx jsx */

import { jsx } from '@emotion/react'
import { SecondaryButton } from '@zcode-ui/controls'
import { selectIsBot } from '@zcode-ui/web-zumper-global-state'
import type { Origin } from '@zcode/nr-utils'
import type { AnalyticsC } from '@zcode/nr-utils'
import type { Listable } from '@zcode/state-type'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ContactContainer } from '../../Contact/ContactContainer'
import { InfoIcon } from '../InfoIcon/InfoIcon'
import { InfoOverlayContainer } from '../InfoOverlay/InfoOverlayContainer'
import { ListItemDesktopViewDetails } from './ListItemDesktopViewDetails'
import * as styles from './style'

export interface Props {
  analyticChannel: typeof AnalyticsC.LIST | typeof AnalyticsC.LIST_ITEM_MESSAGED
  entity: Listable
  origin: Origin
  showInfo: boolean
  setShowInfo: React.Dispatch<React.SetStateAction<boolean>>
}

export const ListItemDesktopViewContent = ({
  analyticChannel,
  entity,
  origin,
  showInfo,
  setShowInfo,
}: Props) => {
  const { headerText, isLargeListCard, isUnavailable } = entity
  const isBot = useSelector(selectIsBot)
  const location = useLocation()
  return (
    <div css={styles.infoContent}>
      <div css={showInfo && styles.displayNone}>
        <ListItemDesktopViewDetails entity={entity} setShowInfo={setShowInfo} showInfo={showInfo} />
      </div>
      <div css={[styles.infoIcon, !showInfo && styles.displayNone]}>
        <InfoIcon
          headerText={headerText}
          location={location}
          setShowInfo={setShowInfo}
          showInfo={showInfo}
          size={16}
        />
      </div>
      <InfoOverlayContainer
        entity={entity}
        isBot={isBot}
        isLargeCard={isLargeListCard}
        isMobile={false}
        showInfo={showInfo}
      />
      <div css={[styles.contact, showInfo && styles.displayNone]}>
        {!isUnavailable && (
          <ContactContainer analyticChannel={analyticChannel} entity={entity} origin={origin} />
        )}
        {isUnavailable && (
          <SecondaryButton css={styles.unavailableBtn}>View details</SecondaryButton>
        )}
      </div>
    </div>
  )
}
